import PostDeviationSelector from './PostDeviationSelector';
export default PostDeviationSelector;

//# sourceMappingURL=index.js.map